import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { BaseEntityResolver } from './resolver.helper';
import { getNewsFetched } from '../State/selectors/news.selector';
import { NewsActionTypes } from '../State/actions/news.actions';

@Injectable({
    providedIn: 'root',
})
export class NewsResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getNewsFetched, NewsActionTypes.LoadAll(), store);
    }
}
